const authRoute = [];

export default authRoute;
